import { render, staticRenderFns } from "./GenericPopup.vue?vue&type=template&id=3fe2a6fa&scoped=true"
import script from "./GenericPopup.vue?vue&type=script&lang=js"
export * from "./GenericPopup.vue?vue&type=script&lang=js"
import style0 from "./GenericPopup.vue?vue&type=style&index=0&id=3fe2a6fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2a6fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe2a6fa')) {
      api.createRecord('3fe2a6fa', component.options)
    } else {
      api.reload('3fe2a6fa', component.options)
    }
    module.hot.accept("./GenericPopup.vue?vue&type=template&id=3fe2a6fa&scoped=true", function () {
      api.rerender('3fe2a6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/GenericPopup.vue"
export default component.exports